import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../Button/Button";
import { baseUrl } from "../../utils/base_url";
import { useMediaQuery } from "react-responsive";
import {
  _1200px,
  _1400px,
  _1600px,
  _1500px,
  _1700px,
  _1800px,
  _576px,
  _768px,
  _992px,
  _2200px,
  _991px,
} from "../../utils/mediaBreakpoints";

const Solo_PractitionersTop = ({
  heading,
  subHeading,
  btntext,
  btnbg,
  imgsrc1,
  imgsrc2,
  imgsrc3,
  isMobile,
  btnclr,
  btnurl,
  texttopmargin,
  toppadding,
  headingfs,
  bottomtext,
  headinglh,
  imgsrcs,
  issBottom,
}) => {
  const navigate = useNavigate();
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _991 = useMediaQuery({ maxWidth: _991px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1500 = useMediaQuery({ maxWidth: _1500px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  const _2200 = useMediaQuery({ maxWidth: _2200px });

  ///
  console.log(
    _576,
    _768,
    _992,
    _1200,
    _1400,
    _1600,
    _1700,
    _1800,
    subHeading,
    subHeading?.replace("what n", "what <br/>")
  );
  return (
    <>
      <div
        className="container px-0 contwidth"
        style={{
          paddingBottom: "8rem",
          paddingTop: _576
            ? "5rem"
            : _768
            ? "5rem"
            : _992
            ? "5rem"
            : _1200
            ? "5rem"
            : _1400
            ? "5rem"
            : _1500
            ? "5rem"
            : _1600
            ? "5rem"
            : _1700
            ? "6rem"
            : _1800
            ? "7rem"
            : "7rem",
          color: "#fff",
          // paddingTop: isMobile ? "" : toppadding,
        }}
      >
        <div className="row">
          <div className={`${issBottom ? "col-lg-5" : "col-lg-6"}`}>
            <div
              className=" d-flex flex-column h-100"
              style={{
                paddingTop: _576
                  ? "3rem"
                  : _768
                  ? "4rem"
                  : _992
                  ? "5rem"
                  : _1200
                  ? "6rem"
                  : _1400
                  ? "7rem"
                  : _1500
                  ? issBottom
                    ? "4rem"
                    : "7rem"
                  : _1600
                  ? "7rem"
                  : _1700
                  ? "9rem"
                  : _1800
                  ? "9rem"
                  : "9rem",
              }}
            >
              <p
                style={{
                  fontWeight: "900",
                  width: issBottom
                    ? _992
                      ? "100%"
                      : _1200
                      ? "90%"
                      : _1400
                      ? "86%"
                      : _1500
                      ? "82%"
                      : _1600
                      ? "85%"
                      : _1700
                      ? "90%"
                      : _1800
                      ? "100%"
                      : "100%"
                    : "",
                  fontSize: _576
                    ? "42px"
                    : _768
                    ? "45px"
                    : _992
                    ? "45px"
                    : _1200
                    ? issBottom
                      ? "47.5px"
                      : "50px"
                    : _1400
                    ? issBottom
                      ? "55px"
                      : "50px"
                    : _1500
                    ? issBottom
                      ? "62px"
                      : "57px"
                    : _1600
                    ? issBottom
                      ? "65px"
                      : "58px"
                    : _1700
                    ? issBottom
                      ? "70px"
                      : "57px"
                    : _1800
                    ? issBottom
                      ? "80px"
                      : "70px"
                    : issBottom
                    ? "90px"
                    : "70px",
                  lineHeight: _576
                    ? "42px"
                    : _768
                    ? "45px"
                    : _992
                    ? "45px"
                    : _1200
                    ? "50px"
                    : _1400
                    ? "55px"
                    : _1500
                    ? "55px"
                    : _1600
                    ? "58px"
                    : _1700
                    ? "60px"
                    : _1800
                    ? "70px"
                    : "70px",
                }}
                className="m-0 lh-1"
              >
                {heading}
              </p>
              {!issBottom && (
                <p
                  style={{
                    fontWeight: "400",
                    fontSize: _576
                      ? "18px"
                      : _768
                      ? "20px"
                      : _992
                      ? "20px"
                      : _1200
                      ? "22px"
                      : _1400
                      ? "26px"
                      : _1500
                      ? "23px"
                      : _1600
                      ? "30px"
                      : _1700
                      ? "30px"
                      : _1800
                      ? "35px"
                      : "35px",
                    // lineHeight: _576
                    //   ? "19px"
                    //   : _768
                    //   ? "20px"
                    //   : _992
                    //   ? "20px"
                    //   : _1200
                    //   ? "22px"
                    //   : _1400
                    //   ? "24px"
                    //   : _1500
                    //   ? "23px"
                    //   : _1600
                    //   ? "35px"
                    //   : _1700
                    //   ? "35px"
                    //   : _1800
                    //   ? "35px"
                    //   : "35px",
                    margin: "1.5rem 0",
                    marginTop: "1.5rem",
                  }}
                  className="lh-1"
                >
                  {subHeading}
                </p>
              )}

              {btntext ? (
                <Button
                  children={btntext}
                  border={"2px solid #1F46BE"}
                  background={btnbg}
                  width={_1600px ? "200px" : "243px"}
                  height={_1600 ? "40px" : "56px"}
                  textColor={btnclr}
                  onClick={() => navigate(btnurl)}
                />
              ) : (
                ""
              )}
            </div>
          </div>
          <div className={`${issBottom ? "col-lg-7" : "col-lg-6"}`}>
            <div
              className={`h-100 d-flex align-items-end justify-content-center gap-2 gap-sm-4 px-lg-0 px-5  mt-lg-0 mt-5`}
            >
              {imgsrcs?.map((imgsrc, idx) => (
                <div
                  style={{
                    width: _768 ? "100%" : _991 ? "154px" : "265.98px",
                    height: _576
                      ? "170px"
                      : _768
                      ? "280px"
                      : _992
                      ? "280px"
                      : _1200
                      ? "300px"
                      : _1400
                      ? issBottom
                        ? "335px"
                        : "317px"
                      : _1500
                      ? issBottom
                        ? "330px"
                        : "350.13px"
                      : _1600
                      ? issBottom
                        ? "340px"
                        : "370.13px"
                      : _1700
                      ? "423.13px"
                      : _1800
                      ? "463.13px"
                      : "463.13px",
                    marginBottom:
                      idx === 0 && _576
                        ? "3.5rem"
                        : idx === 0 && _768
                        ? "4rem"
                        : idx === 0 && _992
                        ? "5.5rem"
                        : idx === 0 && _1200
                        ? "6.5rem"
                        : idx === 0 && _1400
                        ? "6.8rem"
                        : idx === 0 && _1500
                        ? "6rem"
                        : idx === 0 && _1600
                        ? "8rem"
                        : idx === 0 && _1700
                        ? "7rem"
                        : idx === 0 && _1800
                        ? "5rem"
                        : idx === 0 && _2200
                        ? "5rem"
                        : idx === 1 && _576
                        ? "8rem"
                        : idx === 1 && _768
                        ? "9rem"
                        : idx === 1 && _992
                        ? "9.5rem"
                        : idx === 1 && _1200
                        ? "12rem"
                        : idx === 1 && _1400
                        ? "13rem"
                        : idx === 1 && _1500
                        ? "10rem"
                        : idx === 1 && _1600
                        ? "15rem"
                        : idx === 1 && _1700
                        ? "15rem"
                        : idx === 1 && _1800
                        ? "15rem"
                        : idx === 1 && _2200
                        ? "15rem"
                        : "0rem",
                  }}
                >
                  {/* <img
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                    src={`${baseUrl}${imgsrc.url}`}
                    alt="image"
                    key={idx}
                  /> */}
                  {imgsrc?.mime?.includes("video") ? (
                    <div
                      style={{
                        height: "100%",
                        width: "100%",
                      }}
                    >
                      <video
                        autoPlay
                        loop
                        muted
                        className=""
                        style={{
                          objectFit: "cover",
                          height: "100%",
                          width: "100%",
                          borderRadius: "20px",
                        }}
                      >
                        <source
                          src={`${baseUrl}${imgsrc?.url}`}
                          type="video/mp4"
                        />
                        Your browser does not support the video tag.
                      </video>
                    </div>
                  ) : (
                    <img
                      className="d-block"
                      style={{ objectFit: "cover", width:"100%", height:"100%", borderRadius:"20px" }}
                      src={`${baseUrl}${imgsrc?.url}`}
                      alt="..."
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
          {issBottom && (
            <div className="col-12">
              <p
                style={{
                  textAlign: "start",
                  fontWeight: "400",
                  fontSize: _576
                    ? "18px"
                    : _768
                    ? "20px"
                    : _992
                    ? "20px"
                    : _1200
                    ? "22px"
                    : _1400
                    ? "26px"
                    : _1500
                    ? "29px"
                    : _1600
                    ? "30px"
                    : _1700
                    ? "32px"
                    : _1800
                    ? "35px"
                    : "38px",
                  lineHeight: _576
                    ? "19px"
                    : _768
                    ? "20px"
                    : _992
                    ? "20px"
                    : _1200
                    ? "22px"
                    : _1400
                    ? "24px"
                    : _1500
                    ? "23px"
                    : _1600
                    ? "35px"
                    : _1700
                    ? "35px"
                    : _1800
                    ? "35px"
                    : "38px",
                  // margin: "1.5rem 0",
                  marginTop: _991 ? "4rem" : "-4.6rem",
                  marginBottom: _991 ? "0rem" : "4.6rem",
                }}
                dangerouslySetInnerHTML={{
                  __html: _992
                    ? subHeading
                    : subHeading?.replace("what n", "what <br/>"),
                }}
              ></p>
            </div>
          )}
        </div>
        {/* <div className="row justify-content-center py-md-5 py-3 gy-5 gap-4">
          <div className="col-12">
            <div className="d-xl-flex justify-content-center align-items-start text-white gap-3">
              <div
                className={`d-flex-flex-column justify-content-between ${
                  isMobile ? "px-4" : ""
                }`}
                style={{ marginTop: texttopmargin }}
              >
                <p
                  className={`${isMobile ? "fs35" : `${headingfs}`} fw900`}
                  style={{
                    lineHeight: isMobile ? "2rem" : headinglh,
                    wordSpacing: "-5px",
                  }}
                >
                  {heading
                    ? heading
                    : "Makes other platforms look like the 1990’s"}
                </p>
                <p
                  className={`fw400 ${isMobile ? "fs25" : "fs35"}`}
                  style={{ lineHeight: isMobile ? "1.6rem" : "2.3rem" }}
                >
                  {subHeading ? subHeading : ""}
                </p>
                {btntext ? (
                  <Button
                    children={btntext}
                    border={"2px solid #1F46BE"}
                    background={btnbg}
                    className="w-auto fw500 fs20 my-1 px-5"
                    textColor={btnclr}
                    onClick={() => navigate(btnurl)}
                  />
                ) : (
                  ""
                )}
              </div>

              <div
                className="d-lg-flex justify-content-center mx-auto"
                style={{
                  maxWidth: "872px",
                  height: isMobile ? "auto" : "550.13px",
                }}
              >
                <div className="d-flex flex-column flex-md-row gap-4 pt-5 pt-lg-0 h-100">
                  <div
                    className="rounded-3 align-self-center align-self-md-center"
                    style={{
                      backgroundColor: "#D9D9D9",
                      width: "210px",
                      height: "390px",
                    }}
                  >
                    <img
                      src={imgsrc1}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                      className="rounded-3"
                    />
                  </div>

                  <div
                    className="rounded-3 align-self-center align-self-md-start"
                    style={{
                      backgroundColor: "#D9D9D9",
                      width: "210px",
                      height: "390px",
                    }}
                  >
                    <img
                      src={imgsrc2}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                      className="rounded-3"
                    />
                  </div>

                  <div
                    className="rounded-3 align-self-center align-self-md-end "
                    style={{
                      backgroundColor: "#D9D9D9",
                      width: "210px",
                      height: "390px",
                    }}
                  >
                    <img
                      src={imgsrc3}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                      className="rounded-3"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="text-white fs35 fw400"
              style={{
                lineHeight: "2.3rem",
                wordSpacing: "-3px",
                marginTop: "-3.8rem",
              }}
            >
              <p
                dangerouslySetInnerHTML={{
                  __html: bottomtext,
                }}
              ></p>
            </div>
          </div>
          
        </div> */}
      </div>
    </>
  );
};

export default Solo_PractitionersTop;
